import styled from 'styled-components'
import {device} from "src/theme/theme";

export const Box = styled.div<{ hasResponse: boolean }>`
  display: flex;
  flex-direction: column;
  transition: all 0.3s ease 0s;
  position: relative;
  border-left: ${({ hasResponse, theme }) =>
    hasResponse ? `1px solid ${theme.colors.palette.neutral400}` : ''};

  .card {
    display: flex;
    flex-direction: column;
    padding: ${({ hasResponse }) =>
        hasResponse ? '1rem' : '0'}
      1rem 1rem;

    &-header {
      display: flex;
      align-items: center;

      h3 {
        margin: 0.2rem 0 0.2rem 0.5rem;
        ${({ theme }) => ({ ...theme.size.sm })}
      }
    }

    &-body {
      margin-left: 0;
      margin-top: 0.5rem;

      @media ${device.tablet} {
        margin-left: 2.95rem;
        margin-top: 0;
      }

      h3 {
        margin: 0.2rem 0 0.2rem;
        ${({ theme }) => ({ ...theme.size.sm })}
      }

      &-text {
        color: ${({ theme }) => theme.colors.primaryTextColor};
        ${({ theme }) => ({...theme.size.xxs})}
        @media ${device.mobileL} {
          ${({ theme }) => ({...theme.size.xs})}
        }
      }
    }
  }

  .response-text {
    margin-top: 0.2rem;
    span {
      cursor: pointer;
      ${({ theme }) => ({ ...theme.size.xxs })}
      color: ${({ theme }) => theme.colors.secondaryBackgroundColor}
    }
  }
`

export const Image = styled.div<{ image: string }>`
  width: 40px;
  height: 40px;
  border-radius: 50%;
  min-width: 40px;
  div {
    width: 100%;
    height: 100%;
    border-radius: 50%;
    background-image: url(${({ image }) => image});
    background-repeat: no-repeat;
    background-size: cover;
    background-position: center;
    border: 4px solid ${({ theme }) => theme.colors.secondaryBackgroundColor};
  }
`
